import { getLoginAndProfileContainer } from '@/shared/getContainer/getLoginAndProfileContainer'
import { getTvService } from '@/shared/getContainer/getTvService'
import { getEpgService } from '@/shared/getContainer/getEpgService'
import { getVodService } from '@/shared/getContainer/getVodService'
import { ServiceForAPI } from '@/types/containers/ServiceForApiType'
import { apiType } from '@/shared/constants'

export type Service = ServiceForAPI<typeof apiType>

export interface Registry {
    [key: string]: Service
}

export const DIContainer = {
    registry: {
        TVService: await getTvService(),
        EPGService: await getEpgService(),
        VODService: await getVodService(),
        LoginAndProfile: await getLoginAndProfileContainer(),
    } as Registry,

    resolve(identifier: string): Service {
        if (!this.registry.hasOwnProperty(identifier)) {
            throw new Error(
                `Object with identifier ${identifier} not found in container`
            )
        }
        return this.registry[identifier]
    },
}
